import type { Components, Theme } from "@mui/material";

import { IconChevronDown } from "@dfp/react-icons";

import { dropdownPaperStyles } from "./dropdownPaperStyles.ts";

export const selectTheme: Components<Theme>["MuiSelect"] = {
  defaultProps: {
    variant: "filled",
    disableUnderline: true,
    IconComponent: IconChevronDown,
    MenuProps: {
      sx: { zIndex: (theme: Theme) => theme.zIndex.modal },
      PaperProps: {
        elevation: 0,
        sx: dropdownPaperStyles,
      },
    },
  },
  styleOverrides: {
    icon: ({ theme }) => ({
      width: "20px",
      height: "20px",
      top: "calc(50% - 10px)",
      color: theme.palette.custom.icon,
      fill: "none",
    }),
  },
};
